import {MOON_50} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const DetailsPanel = styled.div`
  display: flex;
  padding-top: 20px;
  width: 100%;
  background-color: ${MOON_50};
`;
DetailsPanel.displayName = 'S.DetailsPanel';

export const DetailsMain = styled.div`
  margin: 0 40px;
  flex: 1 1 auto;
  min-width: 0;
`;
DetailsMain.displayName = 'S.DetailsMain';
